import { Box } from "@mui/material";

import CommonSkeleton from "./CommonSkeleton";
import Text from "./text/Text";

function ListItemSkeleton(props) {
  return (
    <Box className="transaction">
      <Box className="left-side">
        <CommonSkeleton variant="circle" height="30px" width="30px" />
        <Box ml="14px">
          <Text className="grey-text" size={12} font="regular">
            <CommonSkeleton width="114px" />
          </Text>
          <Text className="default-text" size={16} font="semibold">
            <CommonSkeleton width="138px" />
          </Text>
        </Box>
      </Box>
      <Box
        className="right-side"
        display="flex"
        flexDirection="column"
        alignItems="end"
      >
        <Text className="grey-text" size={16} font="regular">
          <CommonSkeleton width="71px" />
        </Text>
        <Text className="default-text" size={14} font="semibold">
          <CommonSkeleton width="41px" />
        </Text>
      </Box>
    </Box>
  );
}

export default ListItemSkeleton;
